export enum MetricCardVariant {
    Up = "up",
    Declining = "declining",
    Neutral = "neutral",
}

